import type { App } from 'vue';

import { install as installI18nPlugin, createI18nInstance } from '@libs/i18n';

const i18n = createI18nInstance();

const install = (app: App) => {
  installI18nPlugin(app, i18n);
};

export { install, i18n };
